/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { MeContext } from 'blb-contexts/Me';

import { RoutePermissions, hasPermissions, FALLBACK_ROUTE } from 'blb-utils/permissions';

export namespace PermissionGuard {
  export interface Props {
    children: JSX.Element;
    requiredPermissions?: RoutePermissions;
  }
}

export const PermissionGuard: React.FC<PermissionGuard.Props> = ({ children, requiredPermissions }) => {
  const me = React.useContext(MeContext)!;
  const permissionsGranted = hasPermissions(me.principalType, me.permissions, requiredPermissions);

  if (permissionsGranted) {
    return children;
  }
  return <Redirect to={FALLBACK_ROUTE} />;
};
